import api from "../../utils/api";

export function getInfoMessage(params) {
    return api('/ca/onlc/order/init-cert-order', {
        method: 'POST',
        params: params
    })
}

export function getPrice(params) {
  return api('/ca/onlc/price/search', {
      method: 'POST',
      params: {...params}
  })
}

export function freePostPriceValue(params) {
    return api('/ca/onlc/oss/manage/submit-free', {
        method: 'POST',
        params: params,
    })
}